import { Link } from "react-router-dom";
import { heroStats } from "@/mocks/public";
import AnimatedStatValue from "@/components/base/AnimatedStatValue";

export default function HeroSection() {
  return (
    <section className="relative w-full">
      <div className="relative h-[600px] md:h-[720px] w-full overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20modern%20West%20African%20city%20skyline%20with%20warm%20terracotta%20and%20ochre%20buildings%20at%20golden%20hour%2C%20geometric%20abstract%20architecture%20shapes%2C%20deep%20shadows%2C%20elegant%20minimal%20editorial%20style%2C%20rich%20warm%20earth%20tones%2C%20dramatic%20contrast%2C%20cinematic%20composition&width=1920&height=1080&seq=hero-immogest-01&orientation=landscape"
          alt="Immeubles modernes dans une ville d'Afrique de l'Ouest au coucher du soleil"
          title="Gestion immobilière Burkina Faso — ImmoBF"
          className="hero-zoom absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="animate-fade-in absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/60 to-foreground-950/80" />

        <div className="relative z-10 flex h-full w-full items-center">
          <div className="container-page w-full">
            <div className="mx-auto max-w-3xl text-center">
              <h1
                className="animate-fade-up text-3xl md:text-5xl font-heading font-semibold leading-tight text-background-50"
                style={{ animationDelay: "80ms" }}
              >
                Gérez vos immeubles et vos emplacements simplement.
              </h1>
              <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <Link
                  to="/inscription"
                  className="group animate-fade-up inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-base font-label font-medium text-background-50 hover:bg-primary-600 hover:-translate-y-0.5 transition-all cursor-pointer sm:w-auto"
                  style={{ animationDelay: "220ms" }}
                >
                  Commencer gratuitement
                  <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
                </Link>
                <Link
                  to="/tarifs"
                  className="animate-fade-up inline-flex w-full items-center justify-center whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-base font-label font-medium text-background-50 hover:bg-background-50/20 hover:-translate-y-0.5 backdrop-blur transition-all cursor-pointer sm:w-auto"
                  style={{ animationDelay: "340ms" }}
                >
                  Voir les tarifs
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-page -mt-14 relative z-20">
        <div
          className="animate-fade-up grid grid-cols-2 gap-3 rounded-lg border border-background-200 bg-background-50 p-4 md:grid-cols-4 md:gap-4 md:p-6"
          style={{ animationDelay: "440ms" }}
        >
          {heroStats.map((stat) => (
            <div key={stat.label} className="stat-block flex items-center gap-3">
              <span className="stat-block__icon flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-secondary-50 text-secondary-600">
                <i className={`${stat.icon} text-xl`} aria-hidden="true" />
              </span>
              <div>
                <AnimatedStatValue value={stat.value} className="text-lg font-heading font-semibold text-foreground-950" />
                <p className="text-xs text-foreground-600">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}